import React from 'react';
import PropTypes from 'prop-types';

const Globals = require('../../../../app/globals');
import Navigator from '../../Navigator';
import BreadCrumbs from '../common/BreadCrumbs';

function getFolder(channelId, folderId, foldersFlat={}) {
    return !!foldersFlat[folderId] ? foldersFlat[folderId] : null;
}

function getFolderBcObj(folderObj) {
    return {
        href: `${Navigator.paths.dashboard_author_channel_view(folderObj.user_id, Globals.view_tokens.author_dash.channel_views.FOLDER)}?fId=${folderObj.id}&cType=${folderObj.content_type}`,
        text: folderObj.name,
        iconClass: 'fa fa-folder',
    }
}

function getFolderLinks(channelId, leafFolderId, foldersFlat={}) {
    let folderBcs = [];
    if (leafFolderId) {
        const folder = getFolder(channelId, leafFolderId, foldersFlat);
        if (!folder) {
            console.error(`NavBreadCrumbs - Cannot find leaf folder ID ${leafFolderId}`)
        }
        else {
            if (folder.gp_id) {
                const grandParentFolder = getFolder(channelId, folder.gp_id, foldersFlat);
                if (!grandParentFolder) {
                    console.error(`NavBreadCrumbs - Cannot find grandparent folder ID ${folder.gp_id}`)
                }
                else {
                    folderBcs.push(getFolderBcObj(grandParentFolder));
                }
            }

            if (folder.parent_id) {
                const parentFolder = getFolder(channelId, folder.parent_id, foldersFlat);
                if (!parentFolder) {
                    console.error(`NavBreadCrumbs - Cannot find parent folder ID ${folder.parent_id}`)
                }
                else {
                    folderBcs.push(getFolderBcObj(parentFolder));
                }
            }

            folderBcs.push(getFolderBcObj(folder));
        }
    }

    return folderBcs;
}

export function ProjectBreadCrumbs(props) {
    const channelBc = {
        href: `${Navigator.paths.dashboard_author_channel_view(props.channel.id)}?cType=${props.project.content_type}`,
        text: props.channel.name,
    };

    let folderBcs = [];
    if (props.project.folder_id) {
        folderBcs = getFolderLinks(props.project.channelId, props.project.folder_id, props.foldersFlat);
    }

    return (
        <BreadCrumbs className="d-none d-sm-block" links={[channelBc].concat(folderBcs)} />
    );
}

ProjectBreadCrumbs.propTypes = {
    project: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        channelId: PropTypes.number.isRequired,
        folder_id: PropTypes.string,
        content_type: PropTypes.oneOf([Globals.content_type.ACTIVITY, Globals.content_type.COURSE]).isRequired,
    }).isRequired,
    channel: PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string.isRequired }).isRequired,
    foldersFlat: PropTypes.object.isRequired,
};

export function ActivityBreadCrumbs(props) {
    const channelBc = {
        href: `${Navigator.paths.dashboard_author_channel_view(props.channel.id)}?cType=${props.project.content_type}`,
        text: props.channel.name,
    };

    let folderBcs = [];
    if (props.project.folder_id) {
        folderBcs = getFolderLinks(props.project.channelId, props.project.folder_id, props.foldersFlat);
    }

    const projectBc = {
        href: `/project/${props.channel.id}/${props.project.id}`,
        text: props.project.name,
        iconClass: 'fa fa-lightbulb-o'
    };

    let links;
    if (!!props.activity) {
        const activityBc = {
            href: `/project/${props.channel.id}/${props.project.id}/activity/${props.activity.id}`,
            text: props.activity.meta_data.title,
        };

        links = [channelBc].concat(folderBcs).concat([projectBc, activityBc]);
    }
    else {
        links = [channelBc].concat(folderBcs).concat([projectBc]);
    }

    return (
        <BreadCrumbs className="d-none d-sm-block" links={links} />
    );
}

ActivityBreadCrumbs.propTypes = {
    project: PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string.isRequired, channelId: PropTypes.number.isRequired, folder_id: PropTypes.string }).isRequired,
    channel: PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string.isRequired }).isRequired,
    activity: PropTypes.shape({ id: PropTypes.number.isRequired, meta_data: PropTypes.shape({ title: PropTypes.string.isRequired }) }), // optional. will provide link to ActivityView
    foldersFlat: PropTypes.object.isRequired,
};

ActivityBreadCrumbs.defaultProps = {};